
export class Sheet {
  id: number = 0
  base_sheet_id: number = 0
  grade: number = 0
  name: string = ""
  room_code: string = ""
  curriculum_id: number = 0
  capture_date: string

  constructor(sheet: any){
    this.id = sheet.id;
    this.base_sheet_id = sheet.base_sheet_id;
    this.grade = sheet.grade;
    this.name = sheet.name;
    this.room_code = sheet.room_code;
    this.curriculum_id = sheet.curriculum_id;
    this.capture_date = sheet.capture_date;
  }
}

export class CramStudent {
  student_code: number
  cram_code: number
  name: string
  nendo: number
  grade: number
  room_code: number
  room_name: string
  class_code: number
  class_name: string

  constructor(student: any){
    this.student_code = student.student_code;
    this.cram_code = student.cram_code;
    this.name = student.name;
    this.nendo = student.nendo;
    this.grade = student.grade;
    this.room_code = student.room_code;
    this.room_name = student.room_name;
    this.class_code = student.class_name;
    this.class_name = student.class_name;
  }
}